import { type GeneralCommonPaths } from '@autone/translations';

import { type DatasetsDataFreshnessStatus } from '../../DataFreshnessWidget.types';
const translationPrefix =
  'data-age.global-widget.details-sidesheet.status-banner.title';

export const alertTitleMap: Record<
  NonNullable<DatasetsDataFreshnessStatus>,
  GeneralCommonPaths
> = {
  all_datasets_old: `${translationPrefix}.all-old`,
  some_datasets_old: `${translationPrefix}.some-old`,
  all_datasets_new: `${translationPrefix}.all-new`,
};
